import { Address } from '@rich-products-corp/providers-richproducts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addAddress } from '@/frontastic/actions/account';

export function useAddAddress() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['add:address'],
    mutationFn: (payload: Address) => addAddress(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['get:account'],
      });
    },
  });
}
